// extracted by mini-css-extract-plugin
module.exports = {"bank-data":"DepositDetailsModalContent_bank-data__JPcuG","bank-data__value":"DepositDetailsModalContent_bank-data__value__igL4C"};